import { CustomerUserListPage } from "@/features/customer-user/pages/CustomerUserListPage";

const CustomerUserList = () => {
  return <CustomerUserListPage />;
};

export default CustomerUserList;
